import { GAME_SIZES } from '@core/js/components/common/GamesView/constants';

export { DISPLAY_MODE, GAME_SIZES } from '@core/js/components/common/GamesView/constants';

export const GAME_WIDTHS = {
    [GAME_SIZES.EXTRA_SMALL]: {
        MOBILE: 65,
        DESKTOP: 65
    },
    // #region @theme
    [GAME_SIZES.SMALL]: {
        MOBILE: 90,
        DESKTOP: 120
    },
    // #endregion
    [GAME_SIZES.MEDIUM]: {
        MOBILE: 120,
        DESKTOP: 150
    },
    [GAME_SIZES.LARGE]: {
        MOBILE: 150,
        DESKTOP: 200
    }
};

// #region @theme
export const SLIDE_SIZES = {
    mobile: 3,
    tablet: 6,
    desktop: 8
};
// #endregion
